import { OfferTypeContainer } from '../../containers/advancedFilters/OfferTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const offerType: IFilter = {
  component: OfferTypeContainer,
};
